export default "__VITE_ASSET__Bn36EVmf__"